var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import "reflect-metadata";
import { Component, Prop, Vue } from "vue-property-decorator";
var isAphaNumericWithSpace = require("../../../lib/validate").isAphaNumericWithSpace;
import ExtendModal from "@/components/ExtendModal.vue";
import InputV2 from "@/components/inputv2.vue";
import Button from "@/components/button.vue";
import { namespace } from "vuex-class";
import startCase from 'lodash/startCase';
var Store = namespace("ts");
var Account = /** @class */ (function (_super) {
    __extends(Account, _super);
    function Account() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.openFilters = false;
        _this.filterList = {
            date: "",
            recipient: "",
            reference: "",
            amount: "",
            status: "",
            bank: "",
        };
        _this.statusGroup = [{ id: 'active', name: 'active' }, { id: 'inactive', name: 'inactive' }, { id: 'pending', name: 'Pending' }, { id: 'INQ', name: 'INQ' }];
        _this.startCase = startCase;
        return _this;
    }
    Account.prototype.mounted = function () {
        this.statusGroup = this.status || this.statusGroup;
    };
    Account.prototype.setStatus = function (status) {
        // @ts-ignore
        this.filterList.status = status.id;
    };
    Account.prototype.clearFilter = function () {
        this.filterList = {};
        // reload filter action
        // @ts-ignore
        this.$router.replace({ query: null });
    };
    Account.prototype.triggerFilter = function () {
        // @ts-ignore
        this.filterList[this.statusText] = this.filterList.status;
        // @ts-ignore
        delete this.filterList.status;
        // @ts-ignore
        this.$router.replace({ query: this.filterList });
    };
    Account.prototype.toggleFilter = function () {
        this.openFilters = !this.openFilters;
    };
    __decorate([
        Prop()
    ], Account.prototype, "placeholder", void 0);
    __decorate([
        Prop()
    ], Account.prototype, "status", void 0);
    __decorate([
        Prop()
    ], Account.prototype, "classes", void 0);
    __decorate([
        Prop()
    ], Account.prototype, "statusText", void 0);
    __decorate([
        Store.Action
    ], Account.prototype, "createReserve", void 0);
    __decorate([
        Store.Getter
    ], Account.prototype, "getReservedAccountsDetails", void 0);
    Account = __decorate([
        Component({
            name: "ReserveAccountFilter",
            components: { ExtendModal: ExtendModal, InputV2: InputV2, Button: Button },
        })
    ], Account);
    return Account;
}(Vue));
export default Account;
